/**
 * Table of Contents Active Item Highlight
 * スクロール位置に応じて、現在表示中のh2タグに対応するTOCアイテムをハイライト（黒ドットを移動）
 */

document.addEventListener('DOMContentLoaded', function () {
  /** Table of Contentsのコンテナ要素（サイドバー + SP モーダルの両方を対象） */
  const tocContainers = document.querySelectorAll(
    '.p-magazine__toc-wrap .lwptoc, .p-magazine__sidebar .lwptoc'
  );
  /** 本文コンテンツ内のh2タグのリスト */
  const headingsNodeList = document.querySelectorAll('.p-magazine__body h2');

  if (!tocContainers.length || !headingsNodeList.length) return;

  /** 全コンテナの .lwptoc_item を結合（PC サイドバー + SP モーダル） */
  const tocItems = Array.from(tocContainers).flatMap(c =>
    Array.from(c.querySelectorAll('.lwptoc_item'))
  );

  if (!tocItems.length) return;

  /** h2タグを配列に変換 */
  const headings = Array.from(headingsNodeList);

  /**
   * h2タグから対応するTOCアイテムを取得
   * 1. リンクの href と見出しの id で対応付け（LWP TOCの仕様に合わせて確実）
   * 2. id が無い場合はテキスト一致でフォールバック
   */
  function getTocItem(heading) {
    if (!heading) return null;

    const headingId = heading.id;
    const headingText = heading.textContent.trim();

    return (
      tocItems.find(item => {
        const link = item.querySelector('a');
        if (!link) return false;

        if (headingId && link.hash) {
          const anchorId = link.hash.slice(1);
          if (anchorId === headingId) return true;
        }

        const tocLabel = link.querySelector('.lwptoc_item_label');
        const tocText = tocLabel
          ? tocLabel.textContent.trim()
          : link.textContent.trim().replace(/^\d+\s*/, '');
        return headingText === tocText;
      }) || null
    );
  }

  /** アクティブなアイテムを更新（同一 href を持つ全アイテムに is-active を付与） */
  function setActiveItem(tocItem) {
    tocItems.forEach(item => item.classList.remove('is-active'));
    if (!tocItem) return;
    const link = tocItem.querySelector('a');
    const href = link?.getAttribute('href');
    tocItems.forEach(item => {
      const itemLink = item.querySelector('a');
      if (href && itemLink?.getAttribute('href') === href) {
        item.classList.add('is-active');
      }
    });
  }

  /**
   * 現在の URL ハッシュに対応する TOC アイテムを取得（見出しの id に依存しない）
   * リンクの href が #currentHash のものを探す
   */
  function getTocItemByHash(hashValue) {
    if (!hashValue) return null;
    return (
      tocItems.find(item => {
        const link = item.querySelector('a');
        return link && link.hash.slice(1) === hashValue;
      }) || null
    );
  }

  /** ハッシュに応じて黒ドットを更新（選択して移動した直後に確実に反映） */
  function updateActiveByHash() {
    const hash = window.location.hash.slice(1);
    const tocItem = getTocItemByHash(hash);
    if (tocItem) setActiveItem(tocItem);
  }

  /** スクロール位置に応じて、現在表示中のh2タグに対応するTOCアイテムにis-activeクラスを追加 */
  function handleIntersection(entries) {
    /** 現在ビューポート内にあるh2タグ */
    const intersectingHeadings = entries
      .filter(entry => entry.isIntersecting)
      .map(entry => entry.target);

    let activeHeading = null;

    if (intersectingHeadings.length > 0) {
      // ビューポート内にh2タグがある場合：最も上部に近いものを選択
      activeHeading = intersectingHeadings.sort(
        (a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top
      )[0];
    } else {
      // ビューポート内にh2タグがない場合：スクロール位置より上にある最後のh2タグを選択
      let lastHeadingAboveViewport = null;
      let maxTop = -Infinity;

      headings.forEach(heading => {
        const rect = heading.getBoundingClientRect();
        // rect.top < 0 は、h2タグがビューポートより上にあることを意味する
        if (rect.top < 0 && rect.top > maxTop) {
          maxTop = rect.top;
          lastHeadingAboveViewport = heading;
        }
      });

      // スクロール位置より上にh2タグがない場合（ページ最上部）は、未選択
      activeHeading = lastHeadingAboveViewport;
    }

    if (activeHeading) {
      const tocItem = getTocItem(activeHeading);
      if (tocItem) {
        setActiveItem(tocItem);
      }
    }
  }

  /** h2タグの表示状態を監視するためのIntersection Observerを作成 */
  const observer = new IntersectionObserver(handleIntersection);

  // すべてのh2タグを観測対象に追加
  headings.forEach(heading => {
    observer.observe(heading);
  });

  // 初期状態を設定（ページ読み込み時に実際の表示状態をチェック）
  const initialEntries = headings.map(heading => ({
    target: heading,
    isIntersecting:
      heading.getBoundingClientRect().top >= 0 &&
      heading.getBoundingClientRect().top < window.innerHeight,
  }));
  handleIntersection(initialEntries);

  // Tab+Enter やクリックで目次リンクを開いた直後、黒ドットを該当アイテムに移動
  // ハッシュはリンクの href と一致するので、見出しの id ではなく「href が #hash のリンク」を探す
  window.addEventListener('hashchange', updateActiveByHash);

  // 目次内のリンククリック／Enter 直後は hashchange やスクロールが遅れることがあるため、クリック時にも遅延で更新
  tocItems.forEach(item => {
    const link = item.querySelector('a');
    if (!link) return;
    link.addEventListener('click', () => {
      // ハッシュ更新・スクロール後に黒ドットを移動
      setTimeout(updateActiveByHash, 10);
      setTimeout(updateActiveByHash, 150);
    });
  });
});
